import { apiRequest } from "./apiClient";

export type UploadForReviewResult = {
  readonly generatedContractId: string;
  readonly storedFileId: string;
};

type BackendUploadResponse = {
  readonly success: boolean;
  readonly data: {
    readonly generated_contract_id: string;
    readonly stored_file_id: string;
  };
};

export async function uploadContractForReview(input: {
  readonly file: File;
  readonly displayName: string;
  readonly contractOrigination: string;
  readonly contractType?: string;
  readonly businessUnit?: string;
  readonly reviewerUserId?: string;
}): Promise<UploadForReviewResult> {
  const body = new FormData();
  body.append("file", input.file);
  body.append("display_name", input.displayName);
  body.append("contract_origination", input.contractOrigination);
  if (input.contractType?.trim()) {
    body.append("contract_type", input.contractType.trim());
  }
  if (input.businessUnit?.trim()) {
    body.append("business_unit", input.businessUnit.trim());
  }
  if (input.reviewerUserId?.trim()) {
    body.append("reviewer_user_id", input.reviewerUserId.trim());
  }

  const response = await apiRequest(
    "/generated-contracts/upload-for-review",
    { method: "POST", body },
    { requiresAuth: true }
  );
  const json = (await response.json()) as BackendUploadResponse;
  return {
    generatedContractId: json.data.generated_contract_id,
    storedFileId: json.data.stored_file_id
  };
}
